import moment from 'moment';

export class DateTimeHelper {
  static DB_DATE_FORMAT = 'YYYY/MM/DD';
  static MONTH_FORMAT = 'MM/YY';

  static getJSDateFromFormattedString = (formattedString: string): Date => moment(formattedString, this.DB_DATE_FORMAT).toDate();
  static getJSDateFromString = (formattedString: string): Date => moment(formattedString).toDate();
  static getYearMonthFromString = (formattedString: string): Date => {
    const m = moment(formattedString);
    return new Date(m.year(), m.month());
  };

  static getJSDateFromDotNetDate = (dotNetDate: string): Date => {
    const match = /\/Date\((-?\d+)(?:[+-]\d+)?\)\//.exec(dotNetDate);
    return match ? new Date(parseInt(match[1], 10)) : null;
  };

  static getDBValue = (value: moment.MomentInput): string => moment(value).format(this.DB_DATE_FORMAT);

  static getFormattedValue = (value: moment.MomentInput, format: string): string => moment(value).format(format);

  static isInvalidDate = (value: string): boolean => {
    const date = new Date(value);
    return isNaN(date.getTime());
  };

  static isSameDate = (left: moment.MomentInput, right: moment.MomentInput): boolean => moment(left).isSame(right);

  static getLocaleTime = (value: moment.MomentInput): string => moment(value).format('LT');
}
